import React from 'react';
import '../styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { HIDDEN, FADE, MODE_SOLO, CYAN, MAGENTA, MODE_FRIEND } from '../../HOME/const';
import HelpIcon from '../../HOME/SVG/HelpIcon';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';
import { REQUEST_RESET_STATS_ON, GOTO_HELP_FROM_GAME_PAGE, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import RadioIcon from '../../HOME/SVG/RadioIcon';
import AlternateIcon from '../../HOME/SVG/AlternateIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import TextIcon from '../../HOME/SVG/TextIcon';
import { SET_TURN, SET_OPTION, SHOW_PILE } from '../REDUX/actions';

const Options = props => {
  const dispatch = useDispatch();
  const pn = useSelector(state => state.pn);
  const { whoStarts } = pn.options;

  const handleResetStats = e => {
    if (canResetStats()) {
      props.hideOptions();
      dispatch(REQUEST_RESET_STATS_ON);
    }
  };

  const canResetStats = () => {
    const { stats } = pn;
    return stats && stats.plays > 0;
  };

  const handleHelp = () => {
    props.hideOptions();
    dispatch(GOTO_HELP_FROM_GAME_PAGE);
  };

  const handleLeaders = () => {
    props.hideOptions();
    dispatch({ type: SHOW_LEADERS });
  };

  const handleWhoStarts = who => e => {
    dispatch({ type: SET_OPTION, payload: { name: 'whoStarts', value: who } });

    if (!pn.started && who !== 3 && who !== pn.turn) {
      dispatch({ type: SET_TURN, turn: who });
    }
  };

  const handleShowPile = () => {
    props.hideOptions();
    dispatch({ type: SHOW_PILE, show: true });
  };

  const { op } = props;
  const optionsVisibility = op === HIDDEN ? 'none' : 'inline';

  return (
    <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
      <div className="options-x" onClick={props.hideOptions}>
        ×
      </div>
      <div className={`options-item${canResetStats() ? '' : ' options-item-disabled'}`} onClick={handleResetStats}>
        <ResetStatsIcon width="30" />
        <span>reset stats</span>
      </div>
      {pn.mode === MODE_SOLO ? null : (
        <>
          <div className="options-item" onClick={handleWhoStarts(1)} id="player1-starts-button">
            <RadioIcon width="30" color={CYAN} on={(whoStarts || 1) === 1} />
            <span>player 1 always goes first</span>
          </div>
          <div className="options-item" onClick={handleWhoStarts(2)} id="player2-starts-button">
            <RadioIcon width="30" color={MAGENTA} on={whoStarts === 2} />
            <span>player 2 always goes first</span>
          </div>
          <div className="options-item" onClick={handleWhoStarts(3)} id="players-alternate-button">
            <AlternateIcon width="30" on={whoStarts === 3} color1={CYAN} color2={MAGENTA} />
            <span>players alternate</span>
          </div>
        </>
      )}
      {pn.mode !== MODE_FRIEND && (
        <div className="options-item" onClick={handleLeaders}>
          <TrophyIcon width="30" />
          <span>high scores</span>
        </div>
      )}
      <div className="options-item" onClick={handleShowPile}>
        <TextIcon width="30" count={pn.inPileCount || ''} color="hotpink" />
        <span>show draw pile</span>
      </div>
      <div className="options-item" onClick={handleHelp}>
        <HelpIcon width="30" />
        <span>how to play</span>
      </div>
      <VolumeControl />
    </div>
  );
};

export default Options;
